import plaintextrequest from '@/utils/plaintextrequest'
import request from '@/utils/request'


export function getGameActivity(data) {
	return plaintextrequest({
		url: '/PublicH5/newsdetail',
		method: 'post',
		data
	})
}

export function requestSlideUrl(data) {
	return plaintextrequest({
		url: '/Game/gameSlidenew',
		method: 'post',
		data
	})
}


export function transactionredemption(data) {
	return request({
		url: '/XhRecovery/redeem',
		method: 'post',
		data
	})
}

// 游戏抵扣券
export function gameDeduction(data) {
	// console.log('gameDeduction-----------------', data)
	return request({
		url: '/coupon/lists_xh',
		method: 'post',
		data
	})
}

export function getGameGift(data) {
	// console.log(data)
	return request({
		url: '/gameindex/giftlists',
		method: 'post',
		data
	})
}

export function xiaohaolist(data) {
	return request({
		url: '/user/xhlists',
		method: 'post',
		data
	})
}

// 游戏活动
export function activelists(data) {
	console.log('activit---------------',data)
	return plaintextrequest({
		url: '/gameindex/activelists',
		method: 'post',
		data,
		// tokenflag:'false',
		// isEncipher:'false'
	})
}
// 搜索游戏
export function toSearchall(data) {
	return plaintextrequest({
		url: "/game/toSearchall",
		method: "post",
		data,
	});
}

export function wkGroupBlacklist(data) {
  return request({
    url: "/GroupWy/wkGroupBlacklist",
    method: "post",
    data,
  });
}